import React, { FunctionComponent } from 'react';
import { Field } from 'formik';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Common
import { GENERAL } from '../../../../constants';

// Components
import { Tile } from '../../../Tile';
import { FormTextField, FormInputMask } from '../FormInputs';

// Properties
import * as styles from './FormPersonal.styles';

const FormPersonal: FunctionComponent = () => {
    return (
        <Tile title={GENERAL.PERSONAL_TITLE}>
            <Box sx={styles.box}>
                <Field
                    name="firstName"
                    label={GENERAL.PERSONAL_FIRSTNAME}
                    fullWidth
                    required
                    component={FormTextField}
                />
                <Field
                    name="lastName"
                    label={GENERAL.PERSONAL_LASTNAME}
                    fullWidth
                    required
                    component={FormTextField}
                />
                <Field
                    name="email"
                    type="email"
                    label={GENERAL.PERSONAL_EMAIL}
                    fullWidth
                    required
                    component={FormTextField}
                />
                <Typography
                    sx={styles.emailCaption}
                    variant="caption"
                >
                    {GENERAL.PERSONAL_EMAIL_DESCRIPTION}
                </Typography>
                <Field
                    name="phoneNumber"
                    fullWidth
                    component={FormInputMask}
                />
            </Box>
            <Box sx={styles.caption}>
                <Typography variant="caption">
                    {GENERAL.REQUIRED}
                </Typography>
            </Box>
        </Tile>
    );
};

export default FormPersonal;
